import { __ } from "@wordpress/i18n";

/**
 * Format Time
 * @param string timestamp The timestamp string
 * @returns
 */
export const formatTime = (timestamp) => {
    if (!timestamp) return "Unknown";

    // Parse as UTC by appending 'Z'
    const date = new Date(timestamp.replace(" ", "T") + "Z");
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffDay > 0) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
    if (diffHour > 0) return `${diffHour} hour${diffHour > 1 ? "s" : ""} ago`;
    if (diffMin > 0) return `${diffMin} minute${diffMin > 1 ? "s" : ""} ago`;
    return "Just now";
};

/**
 * Remove underscore and capitalize the first letter
 */
export const formatStringCap = (str) => {
    if (!str) return "";
    return str
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Format apply_to display with additional filters
 * @param {object} item - Rule item
 * @returns {string} - Formatted string like "Categories, User Role & Product Types"
 */
export const formatApplyToDisplay = (item) => {
    if (!item.apply_to) return "N/A";

    const parts = [];

    // Main apply_to
    parts.push(formatStringCap(item.apply_to));

    // Check if user_roles filter is applied
    if (item.user_roles !== null) {
        parts.push(__("User Role", "wpbean-quantity-controls-for-woocommerce"));
    }

    // Check if product_types filter is applied
    if (item.product_types !== null) {
        parts.push(
            __("Product Types", "wpbean-quantity-controls-for-woocommerce"),
        );
    }

    return parts.length > 1
        ? parts.slice(0, -1).join(", ") + " & " + parts[parts.length - 1]
        : parts.join(", ");
};

/**
 * Custom React Select style for ajax select taxonomies (Ex. WC product cats & tags)
 */
export const reactSelectStylesAjax = ({
    width = "100%",
    isMulti,
    height,
} = {}) => ({
    container: (provided) => ({
        ...provided,
        width: isMulti && !width ? "100%" : width || "100%",
    }),
    control: (provided, state) => ({
        ...provided,
        minHeight: height ? height : "37px",
        borderColor: state.isFocused
            ? "rgb(59 130 246 / 1)"
            : "rgb(209 213 219 /1)",
        borderRadius: "0.5rem",
        boxShadow: state.isFocused
            ? "0 0 0 3px rgba(59, 130, 246, 0.1)"
            : "none",
        "&:hover": {
            borderColor: state.isFocused
                ? "rgb(59 130 246 / 1)"
                : "rgb(209 213 219 /1)",
        },
        cursor: "text",
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: "0.5rem",
        marginTop: "4px",
        boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    }),
    menuList: (provided) => ({
        ...provided,
        padding: "4px",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "#dbeafe"
            : state.isFocused
            ? "#f3f4f6"
            : "white",
        color: state.isSelected ? "#1e40af" : "#374151",
        cursor: "pointer",
        borderRadius: "0.375rem",
        padding: "8px 12px",
        fontSize: "0.875rem",
        "&:active": {
            backgroundColor: "#dbeafe",
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "#dbeafe",
        borderRadius: "9999px",
        padding: "2px 8px",
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "#1e40af",
        fontSize: "0.875rem",
        fontWeight: "500",
        paddingLeft: "5px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "#1e40af",
        borderRadius: "9999px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#bfdbfe",
            color: "#1e3a8a",
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#9ca3af",
        fontSize: "0.875rem",
    }),
    singleValue: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
    }),
    loadingIndicator: (provided) => ({
        ...provided,
        color: "#3b82f6",
    }),
});
